import React, { useState } from "react";
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  Popover,
  Stack,
  alpha,
  useTheme,
} from "@mui/material";
import { KeyboardArrowDown, TableChart } from "@mui/icons-material";

// Senin zaten hazır olan ve hesaplamaları yapan componentlerini içeri alıyoruz
import JobExcelExportButton from "./JobExcelExportButton";
import SondaExcelExportButton from "./SondaExcelExportButton";

export default function CombinedTemplateExportWrapper({ jobId, jobName }) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Tooltip title="T-Şablon İndir (Profil & Sonda)">
        <IconButton
          color="success"
          onClick={handleClick}
          sx={{
            bgcolor: alpha(theme.palette.success.main, 0.05),
            mb: 0.5,
            "&:hover": { bgcolor: alpha(theme.palette.success.main, 0.15) },
          }}
        >
          <TableChart fontSize="small" />
        </IconButton>
      </Tooltip>
      <Typography
        variant="caption"
        sx={{
          fontSize: "0.6rem",
          color: "text.secondary",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
        }}
      >
        T ŞABLON <KeyboardArrowDown sx={{ fontSize: "0.8rem" }} />
      </Typography>

      {/* Tıklanınca açılan pencere */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{ sx: { p: 2, mt: 1, borderRadius: 3, boxShadow: 4 } }}
      >
        <Typography
          variant="caption"
          sx={{
            display: "block",
            textAlign: "center",
            mb: 2,
            color: "text.secondary",
            fontWeight: "bold",
          }}
        >
          İNDİRİLECEK ŞABLONU SEÇİN
        </Typography>
        {/* Butonlara basıldığında menü kapansın diye onClick eklendi (indirme arkada başlar) */}
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="center"
          onClick={handleClose}
        >
          {/* ZATEN HAZIR OLAN EXCEL COMPONENTLERİ BURADA */}
          <JobExcelExportButton jobId={jobId} jobName={jobName} />
          <SondaExcelExportButton jobId={jobId} jobName={jobName} />
        </Stack>
      </Popover>
    </Box>
  );
}
